import { Helmet } from "react-helmet";
import { Box, Button, Container, Divider, Grid, Paper, Skeleton, Stack, Typography } from "@mui/material";
import { CalendarMonthRounded, CancelOutlined, DoneRounded, DriveFolderUploadOutlined, InfoRounded, PaymentsOutlined, StayCurrentPortraitOutlined, StorageRounded } from "@mui/icons-material";
import { useUser } from "../../../lib/hooks";
import { useEffect, useState } from "react";
import { getAllActivePacks, pay } from "../../../lib/services/drive";
import Toasty from "../../../theme/components/Toasty";
import { LoadingButton } from "../../../theme/components/LoadingButton";
import LoginModal from "../../../components/common/loginModal";
import { convertSize } from "../../../lib/commonFunctions/convertSize";

export default function Plans() {

    const user = useUser();
    const [plans, setPlans] = useState([]);
    const [loading, setLoading] = useState(true);
    const [pending, setPending] = useState(0);
    const [selectedPlan, setSelectedPlan] = useState(0);
    const userActivePack = user?.userActivePack;

    const [loginModalOpen, setLoginModalOpen] = useState(false);


    const handleOnPurchaseClick = async (id, isLoggedIn) => {
        if (!user && !isLoggedIn) {
            setLoginModalOpen(true);
            return setSelectedPlan(id);
        };
        setPending(id);
        try {
            const { data } = await pay('package', { packageId: id });
            if (data?.isSuccess) {
                if (data.value?.gatewayUrl) window.location.href = data.value.gatewayUrl;
            } else {
                if (data && data.errors?.length) {
                    setPending(false);
                    data.errors.map(i => Toasty.error(i));
                }
            }
        } catch (err) {
            console.log(err);
            Toasty.error('خطایی غیر منتظره رخ داد')
        }
        setPending(false);
    }

    const getSize = (number) => {
        return convertSize((number * 1024 * 1024), { farsi: true, fixed: true });
    }

    async function getPlans() {
        try {
            const { data } = await getAllActivePacks();
            if (data?.isSuccess) {
                setPlans(data.value);
            } else {
                if (data && data.errors?.length) {
                    data.errors.map(i => Toasty.error(i));
                }
            }
        } catch (err) {
            console.log(err);
            Toasty.error('خطایی پیش آمد');
        }
        setLoading(false);
    }
    useEffect(() => {
        getPlans();
    }, []);

    return (
        <>
            <Helmet>
                <title>تعرفه ها - میلفا</title>
            </Helmet>
            <Container sx={{ mt: 3, mb: 7 }}>
                <Grid mt={0} container spacing={3} justifyContent="center">
                    <Grid item xs={12} container justifyContent="center">
                        <Grid item xs={12} lg={9}>
                            <Paper sx={{ p: 2.5, borderRadius: 2 }} elevation={25}>
                                <Typography component="h1" fontSize={{ xs: "1.1rem", lg: "1.2rem" }} fontWeight={600} textAlign="center">لیست تعرفه ها</Typography>
                                <Typography mt={.5} fontSize={{ xs: ".825rem", lg: ".9rem" }} textAlign="center">تعرفه مورد نظر خود را انتخاب کنید</Typography>
                            </Paper>
                        </Grid>
                    </Grid>
                    {!loading
                        ?
                        plans.length
                            ?
                            plans.map((p, ind) => (
                                <Grid key={ind} item xs={12} lg={3}>
                                    <Box sx={{ width: 1, position: "relative", background: theme => theme.palette.background.box, borderRadius: 1, boxShadow: "0 0 15px -6px rgb(66 66 66 / 25%)" }}>
                                        {/* Header */}
                                        <Box display="flex" alignItems="center" justifyContent="center" flexDirection="column" sx={{ width: 1, p: 2, background: theme => theme.palette.primary.main, borderTopRightRadius: "inherit", borderTopLeftRadius: "inherit" }}>
                                            <Box sx={{ p: 1.5, width: 75, height: 75, background: theme => theme.palette.background.box, borderRadius: '50%' }}>
                                                <Box component="img" src="/assets/image/icon/reward.png" width={1} height={1} sx={{ objectFit: "contain" }} />
                                            </Box>
                                            <Typography mt={1.5} color="primary" component="h3" fontSize={{ xs: "1.1rem" }} fontWeight={500} textAlign="center" sx={{ width: 1, background: theme => theme.palette.background.box, p: 2, borderRadius: 1.5 }}>{p.name}</Typography>
                                        </Box>
                                        <Box sx={{ p: 2 }}>
                                            <Stack spacing={2} divider={<Divider />}>
                                                <Stack direction="row" alignItems="center" spacing={1}>
                                                    <Box display="flex" alignItems="center">
                                                        <StorageRounded sx={{ fontSize: "1.1rem", color: theme => theme.palette.grey.dark }} />
                                                        <Typography fontSize={{ xs: ".875rem", lg: ".925rem" }} ml={.75}>توضحیات:</Typography>
                                                    </Box>
                                                    <Typography fontSize={{ xs: ".875rem", lg: ".925rem" }} fontWeight={500}>{p.description}</Typography>
                                                </Stack>
                                                <Stack direction="row" alignItems="center" spacing={1}>
                                                    <Box display="flex" alignItems="center">
                                                        <StorageRounded sx={{ fontSize: "1.1rem", color: theme => theme.palette.grey.dark }} />
                                                        <Typography fontSize={{ xs: ".875rem", lg: ".925rem" }} ml={.75}>حجم:</Typography>
                                                    </Box>
                                                    <Typography fontSize={{ xs: ".875rem", lg: ".925rem" }} fontWeight={500}>{getSize(p.driveSize)}</Typography>
                                                </Stack>
                                                <Stack direction="row" alignItems="center" spacing={1}>
                                                    <Box display="flex" alignItems="center">
                                                        <PaymentsOutlined sx={{ fontSize: "1.1rem", color: theme => theme.palette.grey.dark }} />
                                                        <Typography fontSize={{ xs: ".875rem", lg: ".925rem" }} ml={.75}>مبلغ:</Typography>
                                                    </Box>
                                                    <Typography fontSize={{ xs: ".875rem", lg: ".925rem" }} fontWeight={500}>{p.price ? `${p.price.toLocaleString('fa-IR')} ریال` : "رایگان"}</Typography>
                                                </Stack>
                                                <Stack direction="row" alignItems="center" spacing={1}>
                                                    <Box display="flex" alignItems="center">
                                                        <StayCurrentPortraitOutlined sx={{ fontSize: "1.1rem", color: theme => theme.palette.grey.dark }} />
                                                        <Typography fontSize={{ xs: ".875rem", lg: ".925rem" }} ml={.75}>اشتراک موبایل:</Typography>
                                                    </Box>
                                                    <YesOrNo boolean={p.allowMobileSharing} />
                                                </Stack>
                                                <Stack direction="row" alignItems="center" spacing={1}>
                                                    <Box display="flex" alignItems="center">
                                                        <DriveFolderUploadOutlined sx={{ fontSize: "1.1rem", color: theme => theme.palette.grey.dark }} />
                                                        <Typography fontSize={{ xs: ".875rem", lg: ".925rem" }} ml={.75}>حداکثر حجم آپلود:</Typography>
                                                    </Box>
                                                    <Typography fontSize={{ xs: ".875rem", lg: ".925rem" }} fontWeight={500}>{getSize(p.fileUploadSize)}</Typography>
                                                </Stack>
                                                <Stack direction="row" alignItems="center" spacing={1}>
                                                    <Box display="flex" alignItems="center">
                                                        <CalendarMonthRounded sx={{ fontSize: "1.1rem", color: theme => theme.palette.grey.dark }} />
                                                        <Typography fontSize={{ xs: ".875rem", lg: ".925rem" }} ml={.75}>دوره:</Typography>
                                                    </Box>
                                                    <Typography fontSize={{ xs: ".875rem", lg: ".925rem" }} fontWeight={500}>{p.period?.toLocaleString('fa-IR')} روزه</Typography>
                                                </Stack>
                                            </Stack>
                                            {userActivePack?.id !== p.id
                                                ?
                                                <LoadingButton
                                                    onClick={() => handleOnPurchaseClick(p.id)}
                                                    loading={pending === p.id}
                                                    variant="contained" fullWidth
                                                    sx={{ py: 1.5, mt: 3 }}
                                                    disableElevation>خرید</LoadingButton>
                                                :
                                                <Button
                                                    disabled variant="contained"
                                                    fullWidth disableElevation
                                                    startIcon={<DoneRounded />}
                                                    sx={{ py: 1.5, mt: 3, backgroundColor: theme => theme.palette.success.main + "!important", color: "#fff!important" }}>فعال شده</Button>
                                            }
                                        </Box>
                                    </Box>
                                </Grid>
                            ))
                            :
                            <Grid item xs={12} lg={6}>
                                <Paper sx={{ p: 2.5, minHeight: { xs: "50vw", lg: "20vw" }, display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }} elevation={2}>
                                    <InfoRounded color="warning" sx={{ fontSize: "3.5rem" }} />
                                    <Typography mt={1} fontSize={{ lg: "1.1rem" }} fontWeight={600}>متاسفانه تعرفه ای پیدا نشد!</Typography>
                                </Paper>
                            </Grid>
                        :
                        <LoadingSkeleton />
                    }
                </Grid>
            </Container>
            {/* Login Modal */}
            <LoginModal
                open={loginModalOpen}
                onClose={() => setLoginModalOpen(false)}
                options={{ onSuccess: () => handleOnPurchaseClick(selectedPlan, true), noReload: true }} />
        </>
    )
}

const YesOrNo = ({ boolean }) => {
    switch (boolean) {
        case true: return <DoneRounded color="success" fontSize="small" />
        case false: return <CancelOutlined color="error" fontSize="small" />;
        default: return <CancelOutlined color="error" fontSize="small" />;
    }
}
const LoadingSkeleton = () => {
    return (
        Array.from([...Array(4)].map((_, ind) => (
            <Grid key={ind} item xs={12} lg={3}>
                <Box sx={{ width: 1, position: "relative", background: theme => theme.palette.background.box, borderRadius: 1, boxShadow: "0 0 15px -6px rgb(66 66 66 / 25%)" }}>
                    {/* Header */}
                    <Box display="flex" alignItems="center" justifyContent="center" flexDirection="column" sx={{ width: 1, p: 2, background: theme => theme.palette.primary.main, borderTopRightRadius: "inherit", borderTopLeftRadius: "inherit" }}>
                        <Box sx={{ p: 1.5, width: 75, height: 75, background: theme => theme.palette.background.box, borderRadius: '50%' }}>
                            <Box component="img" src="/assets/image/icon/reward.png" width={1} height={1} sx={{ objectFit: "contain" }} />
                        </Box>
                        <Skeleton width="100$" />
                    </Box>
                    <Box sx={{ p: 2 }}>
                        <Stack spacing={2} divider={<Divider />}>
                            <Stack direction="row" alignItems="center" spacing={1}>
                                <Box display="flex" alignItems="center">
                                    <StorageRounded sx={{ fontSize: "1.1rem", color: theme => theme.palette.grey.dark }} />
                                    <Typography fontSize={{ xs: ".875rem", lg: ".925rem" }} ml={.75}>توضحیات:</Typography>
                                </Box>
                                <Skeleton width="5rem" />
                            </Stack>
                            <Stack direction="row" alignItems="center" spacing={1}>
                                <Box display="flex" alignItems="center">
                                    <StorageRounded sx={{ fontSize: "1.1rem", color: theme => theme.palette.grey.dark }} />
                                    <Typography fontSize={{ xs: ".875rem", lg: ".925rem" }} ml={.75}>حجم:</Typography>
                                </Box>
                                <Skeleton width="5rem" />
                            </Stack>
                            <Stack direction="row" alignItems="center" spacing={1}>
                                <Box display="flex" alignItems="center">
                                    <PaymentsOutlined sx={{ fontSize: "1.1rem", color: theme => theme.palette.grey.dark }} />
                                    <Typography fontSize={{ xs: ".875rem", lg: ".925rem" }} ml={.75}>مبلغ:</Typography>
                                </Box>
                                <Skeleton width="5rem" />
                            </Stack>
                            <Stack direction="row" alignItems="center" spacing={1}>
                                <Box display="flex" alignItems="center">
                                    <StayCurrentPortraitOutlined sx={{ fontSize: "1.1rem", color: theme => theme.palette.grey.dark }} />
                                    <Typography fontSize={{ xs: ".875rem", lg: ".925rem" }} ml={.75}>اشتراک موبایل:</Typography>
                                </Box>
                                <Skeleton width="5rem" />
                            </Stack>
                            <Stack direction="row" alignItems="center" spacing={1}>
                                <Box display="flex" alignItems="center">
                                    <DriveFolderUploadOutlined sx={{ fontSize: "1.1rem", color: theme => theme.palette.grey.dark }} />
                                    <Typography fontSize={{ xs: ".875rem", lg: ".925rem" }} ml={.75}>حداکثر حجم آپلود:</Typography>
                                </Box>
                                <Skeleton width="5rem" />
                            </Stack>
                            <Stack direction="row" alignItems="center" spacing={1}>
                                <Box display="flex" alignItems="center">
                                    <CalendarMonthRounded sx={{ fontSize: "1.1rem", color: theme => theme.palette.grey.dark }} />
                                    <Typography fontSize={{ xs: ".875rem", lg: ".925rem" }} ml={.75}>دوره:</Typography>
                                </Box>
                                <Skeleton width="5rem" />
                            </Stack>
                        </Stack>
                        <Button
                            disabled
                            variant="contained" fullWidth
                            sx={{ py: 1.5, mt: 3 }}
                            disableElevation>خرید</Button>
                    </Box>
                </Box>
            </Grid>
        )))
    )
}